import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCountries', 'countries'),
  ...generateMutations('getCountry', 'country'),
}
